"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CREDIT_INFO = void 0;
var CREDIT_INFO = {
  INPUT__CUSTOMER_SEARCH: 'newCreditNoteCreditInfo-input-customerSearch',
  BUTTON__CUSTOMER_RESULT: 'newCreditNoteCreditInfo-button-customerResult',
  TEXT__CUSTOMER_RESULT_NAME: 'newCreditNoteCreditInfo-span-customerName',
  TEXT__SELECTED_CUSTOMER_NAME: 'newCreditNoteCreditInfo-text-selectedCustomerName',
  BUTTON__REMOVE_SELECTED_CUSTOMER: 'newCreditNoteCreditInfo-button-removeCustomer',
  LABEL__NON_STOCK_CREDIT: 'newCreditNoteCreditInfo-label-nonStockCredit',
  INPUT__NON_STOCK_CREDIT: 'newCreditNoteCreditInfo-input-nonStockCredit'
};
exports.CREDIT_INFO = CREDIT_INFO;